import { render, staticRenderFns } from "./UnionOverviewNewsListWithSubtitle.vue?vue&type=template&id=0e5be292&scoped=true"
import script from "./UnionOverviewNewsListWithSubtitle.vue?vue&type=script&lang=js"
export * from "./UnionOverviewNewsListWithSubtitle.vue?vue&type=script&lang=js"
import style0 from "./UnionOverviewNewsListWithSubtitle.vue?vue&type=style&index=0&id=0e5be292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5be292",
  null
  
)

export default component.exports